import { get, put, del, toastErrorHandle } from './http-methods';

export const mapEntity = (data) => {
  return {
    id: data.id,
    createdAt: data.released_at ? new Date(data.released_at) : null,
    creatorName: data.publisher_name,
    status: data.status,
    isArchive: data.status === 'ARCHIVED',
    ...(data.application_update && {
      application_update: data.application_update.toLowerCase(),
    }),
  };
};
const APPLICATION_UPDATES = ['optional', 'mandatory'];
const sortDescByDate = (releases) =>
  [...releases].sort((a, b) => b.createdAt - a.createdAt);
const addKeyShowRefreshIcon = (releases) => {
  let updatedReleases = [];
  for (let i = 0; i < releases.length; i++) {
    if (APPLICATION_UPDATES.includes(releases[i].application_update)) {
      updatedReleases.push({ ...releases[i], showRefreshIcon: false });
      updatedReleases = updatedReleases.concat(releases.slice(i + 1));
      break;
    }
    updatedReleases.push({ ...releases[i], showRefreshIcon: true });
  }
  return updatedReleases;
};

export default {
  getList() {
    return get('/versions/releases').then(({ json }) => {
      const releasesList = json.data.map(mapEntity);
      const releasesListSorted = sortDescByDate(releasesList);
      const releasesListWithKey = addKeyShowRefreshIcon(releasesListSorted);

      return releasesListWithKey;
    });
  },
  makeDefault(id) {
    return put(`/versions/releases/${id}/current`).then((resp) =>
      resp.status === 200 ? null : toastErrorHandle(resp)
    );
  },
  del(id) {
    return del(`/versions/releases/${id}`).then((resp) =>
      resp.status === 204 ? null : toastErrorHandle(resp)
    );
  },
};
